import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Объединяет классы (условия, массивы, объекты) и разрешает конфликты Tailwind: последний класс побеждает. */
export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs));
}
